import { initializeApp } from "firebase/app";
import { getAuth, PhoneAuthProvider, signInWithCredential } from "firebase/auth";
import { getFirestore,Timestamp, serverTimestamp  } from "firebase/firestore";
import { getStorage, ref, uploadBytes, getDownloadURL } from 'firebase/storage';




const firebaseConfig = {
    apiKey: 'AIzaSyBkuCp4e5BYgoc16PKKfixScaKFU-rcaDc',
    authDomain: 'servicecentral-36b4a.firebaseapp.com',
    projectId: 'servicecentral-36b4a',
    storageBucket: 'servicecentral-36b4a.appspot.com',
    messagingSenderId: '583799858270',
    appId: '1:583799858270:android:b9f702a737ba25e756c0cf',
};

const googleMapAPIKey = "AIzaSyC09PkPm9r5RofCqm167GxGwZATwKPB-lE";



const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
const db = getFirestore(app);
const storage = getStorage(app);


export {firebaseConfig, googleMapAPIKey, auth, db, storage, Timestamp, serverTimestamp, ref, uploadBytes, getDownloadURL, PhoneAuthProvider, signInWithCredential}